module.exports = __webpack_public_path__ + "img/pano-twitch.23713285.jpg";